import config from '../../config/config';

const EmbeddedLink = props => {
  const {url} = props;
  return (
    <a 
      href={url} 
      style={{
        color: config().colors.primary, 
        textDecoration: 'underline', 
        fontWeight: props.bold ? 'bold' : null,
      }} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  );
};

export default EmbeddedLink;